export enum ActionItemAssignedToType {
  PSSRMember = 1,
  ChevronUsr = 2,
  Other = 3,
  Group = 4,
}
